import { render, staticRenderFns } from "./googleotc.vue?vue&type=template&id=36ea1072&scoped=true&"
import script from "./googleotc.vue?vue&type=script&lang=js&"
export * from "./googleotc.vue?vue&type=script&lang=js&"
import style0 from "./googleotc.vue?vue&type=style&index=0&id=36ea1072&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ea1072",
  null
  
)

export default component.exports